<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-list two-line subheader>
          <v-subheader inset>Settings</v-subheader>
          <v-list-item>
            <v-text-field label="Company Code" v-model="company"></v-text-field>
          </v-list-item>
          <v-list-item>
            <v-text-field label="Remote Server" v-model="server"></v-text-field>
          </v-list-item>
          <v-list-item>
            <v-text-field label="Auto Signout Interval (Minutes)" v-model="signoutInterval" type="number" @change="setSignoutInterval"></v-text-field>
          </v-list-item>
          <v-list-item v-for="item in items" v-bind:key="item.title" @click="item.action">
            <v-list-item-avatar>
              <v-icon v-bind:class="[item.iconClass]">{{ item.icon }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.subtitle }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-flex>
    <v-snackbar v-model="snackbar">
      {{snackbarText}}
      <v-btn dark text @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
  import idb from 'idb'
  export default {
    data () {
      return {
        items: [
          { icon: 'history', iconClass: 'grey lighten-1 white--text', title: 'Reset', subtitle: 'Refresh the app to get the latest version', action: this.resetApp }
        ],
        snackbar: false,
        snackbarText: '',
        company: this.$store.getters.company,
        server: localStorage.getItem('remoteServer') !== null && localStorage.getItem('remoteServer') !== undefined ? localStorage.remoteServer : 'https://cwelite.aquariusit.com',
        signoutInterval: localStorage.getItem('signoutInterval') !== null && localStorage.getItem('signoutInterval') !== undefined ? localStorage.signoutInterval : 0
      }
    },
    watch: {
      cameraQuality: function (val) {
        localStorage.setItem('cameraQuality', val)
      },
      company: function (val) {
        this.$store.dispatch('checkCompany', val)
      },
      server: function (val) {
        this.$store.dispatch('setURL', val)
        localStorage.setItem('remoteServer', val)
      }
    },
    methods: {
      resetApp () {
        navigator.serviceWorker.getRegistrations()
          .then(function (registrations) {
            for (let registration of registrations) {
              registration.unregister()
            }
          })
          .then(function (boolean) {
            caches.delete('dms-cache').then(function (boolean) {
              window.location.reload(true)
            })
          })
      },
      clearApp () {
        this.snackbar = true
        this.snackbarText = 'Clearing Data'
        idb.delete('dms-db').then(() => {
          this.snackbar = true
          this.snackbarText = 'Data Cleared'
        })
      },
      setSignoutInterval () {
        this.$store.dispatch('setSignoutInterval', this.signoutInterval)
        localStorage.setItem('signoutInterval', this.signoutInterval)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Settings.vue